import { useContext } from 'react';

import { CollapsibleContext } from '../collapsible.context.ts';

export const useSetClipped = (): ((clipped: boolean) => void) => useContext(CollapsibleContext).setClipped;
